import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Chatbot from "@/components/Chatbot";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const PublicLayout = () => (
  <>
    <ScrollToTop />
    <main className="flex-grow">
      <Outlet />
    </main>
    <Chatbot />
  </>
);

export default PublicLayout;